import { render, staticRenderFns } from "./CategoryDaily.vue?vue&type=template&id=04e59ab7"
import script from "./CategoryDaily.vue?vue&type=script&lang=js"
export * from "./CategoryDaily.vue?vue&type=script&lang=js"
import style0 from "./CategoryDaily.vue?vue&type=style&index=0&id=04e59ab7&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports